import React, {useContext} from "react";

export const FormContext = React.createContext({
  disabled: false,
  requestDisabled: () => {},
});
export function useForm() {
  return useContext(FormContext);
}
